export const REPORT_PROFILE_OPTION_KEYS = Object.freeze([
    'sectionVisibility',
    'sectionOrder',
    'visibleFields',
    'chartVisibility',
    'grouping',
    'tableDensity',
    'topN',
    'narrativeSections',
    'presentation',
]);

export const REPORT_PROFILE_OPTION_KEYS_BY_CLASS = Object.freeze({
    'generic-list': Object.freeze(['visibleFields', 'grouping', 'tableDensity', 'topN', 'presentation']),
    portfolio: Object.freeze(['sectionVisibility', 'sectionOrder', 'visibleFields', 'chartVisibility', 'grouping', 'tableDensity', 'topN', 'narrativeSections', 'presentation']),
    dossier: Object.freeze(['sectionVisibility', 'sectionOrder', 'visibleFields', 'chartVisibility', 'tableDensity', 'narrativeSections', 'presentation']),
    'statutory-template': Object.freeze(['visibleFields', 'tableDensity', 'presentation']),
    'technical-ops': Object.freeze(['visibleFields', 'grouping', 'tableDensity', 'topN', 'presentation']),
});

export function reportProfileOptionKeys(reportClass) {
    return REPORT_PROFILE_OPTION_KEYS_BY_CLASS[reportClass] || Object.freeze([]);
}
